import React from 'react';
import http from '../modules/api';
import DatePicker from "react-datepicker";
import Pagination from "react-js-pagination";
import FileDownloadComponent from "../modules/FileDownloadComponent";
import "react-datepicker/dist/react-datepicker.css";

export class AdminPronotionApplyList extends React.Component {

	state = {
		list: [],
		q: "",
		start_date: null,
		end_date: null,
		start_date_format: "",
		end_date_format: "",
		activePage: 1,
		totalCnt: 0,
		startIdx: 0,
		rowcnt: 10,
		modRemarkList: [],
	}

	componentDidMount() {
		this.getPromotionApplyList();
	}

	componentDidUpdate() {
		let remarkAreas = document.querySelectorAll(".user_remark_text_area");
		if (remarkAreas && remarkAreas.length > 0) {
			for (let idx in remarkAreas) {
				if (remarkAreas[idx].style != null) {
					this.textAreaAutoResize(remarkAreas[idx]);
				}
			}
		}
	}

	getPromotionApplyList = async () => {
		await http.get("/rest/admin/promotionApplyList"
			+ "?q=" + encodeURIComponent(this.state.q || "")
			+ "&start_date=" + (this.state.start_date_format || "")
			+ "&end_date=" + (this.state.end_date_format || "")
			+ "&startidx=" + this.state.startIdx
			+ "&rowcnt=" + this.state.rowcnt
		).then(res => {
			let list = res.data["list"] || [];

			this.setState({
				list: list,
				totalCnt: res.data["totalCnt"] || 0
			});

			for (let idx in list) {
				let remarkName = list[idx].promotion_apply_seq + "_remark";
				this.setState({
					[remarkName]: list[idx].remark || "",
				});
			}
		}).catch(error => {
			console.log(error);
		});
	}

	handleChangeStartDate = date => {
		if (date != null) {
			this.setState({
				start_date_format: date.getFullYear() + "-" + ("0" + parseInt(date.getMonth() + 1)).slice(-2) + "-" + ("0" + parseInt(date.getDate())).slice(-2),
				start_date: date
			});
		} else {
			this.setState({
				start_date_format: "",
				start_date: null
			});
		}
	}

	handleChangeEndDate = date => {
		if (date != null) {
			this.setState({
				end_date_format: date.getFullYear() + "-" + ("0" + parseInt(date.getMonth() + 1)).slice(-2) + "-" + ("0" + parseInt(date.getDate())).slice(-2),
				end_date: date
			});
		} else {
			this.setState({
				end_date_format: "",
				end_date: null
			});
		}
	}

	onClickSearchListButton = () => {
		this.setState({
			startIdx: 0,
			activePage: 1
		}, this.getPromotionApplyList);
	}

	_handleKeyDown = e => {
		if (e.key === 'Enter') {
			this.onClickSearchListButton();
		}
	}

	handlePageChange(pageNumber) {
		this.setState({
			activePage: pageNumber,
			startIdx: (pageNumber * this.state.rowcnt) - this.state.rowcnt
		}, this.getPromotionApplyList);
	}

	onChangeRemarkModText(e, promotion_apply_seq) {
		this.setState({
			[promotion_apply_seq + "_remark"]: e.target.value
		});
	}

	onClickRemarkModButton(promotion_apply_seq) {
		let { modRemarkList } = this.state;
		if (modRemarkList.indexOf(promotion_apply_seq) === -1) {
			modRemarkList.push(promotion_apply_seq);
		}

		this.setState({
			modRemarkList: modRemarkList
		});
	}

	onClickRemarkSaveButton(promotion_apply_seq) {
		let { modRemarkList } = this.state;
		modRemarkList = modRemarkList.filter(function(item) {
			return item !== promotion_apply_seq
		});

		this.setState({
			modRemarkList: modRemarkList
		});

		this.modPromotionApplyRemark(
			promotion_apply_seq,
			this.state[promotion_apply_seq + "_remark"]
		);
	}

	async modPromotionApplyRemark(promotion_apply_seq, remark) {
		const body = {
			promotion_apply_seq: promotion_apply_seq,
			remark: remark,
		}

		const config = {
			headers: {
				'content-type': 'application/json;'
			}
		}

		await http.post("/rest/admin/modPromotionApplyRemark", body, config)
			.then(res => {
				if (res.data.code === "200") {
					this.getPromotionApplyList();
				} else {
					alert("비고 저장 중 오류가 발생했습니다.");
				}
			}).catch(error => {
				console.log(error);
				alert("비고 저장 중 오류가 발생했습니다.");
			});
	}

	textAreaAutoResize(textarea) {
		textarea.style.height = "auto";
		textarea.style.height = (textarea.scrollHeight) + "px";
	}

	getExcelDownloadUrl() {
		return "/rest/admin/promotionApplyList/excel"
			+ "?q=" + encodeURIComponent(this.state.q || "")
			+ "&start_date=" + (this.state.start_date_format || "")
			+ "&end_date=" + (this.state.end_date_format || "");
	}

	render() {
		return (
			<div id='page-wrapper' className="container user_list_container" style={{backgroundColor: '#ffffff', minHeight:"100%"}}>
				<div id="notice_list_component">
					<h4>[Admin]프로모션 신청자 목록</h4>
					<br/>

					<div className="filter" style={{width: "1200px", maxWidth:"100%"}}>
						<div className="input-group m-b mobile-width-100">
							<div style={{width: "100%"}}>
								<label>신청 날짜</label>
								<div className="input-daterange input-group" id="datepicker">
									<DatePicker
										name="start_date"
										id="start_date"
										selected={this.state.start_date}
										onChange={this.handleChangeStartDate}
										dateFormat="yyyy-MM-dd"
										autoComplete='off'
									/>
									<div className="input-group-addon" style={{width: "40px", height:"35px", lineHeight: "34px", textAlign:"center"}}>to</div>
									<DatePicker
										name="end_date"
										id="end_date"
										selected={this.state.end_date}
										onChange={this.handleChangeEndDate}
										dateFormat="yyyy-MM-dd"
										autoComplete='off'
									/>
								</div>
							</div>
						</div>
						<div style={{display:"flex", marginBottom: '12px'}}>
							<input
								type="text"
								onChange={(e) => this.setState({ q: e.target.value })}
								placeholder="업체명 또는 연락처를 입력하세요."
								className="admin_search_input"
								onKeyDown={this._handleKeyDown}
								value={this.state.q}
								style={{flex: "1"}}
							/>
							<button className="greenButton m-r-xs admin_search_btn" onClick={this.onClickSearchListButton} style={{marginRight: "8px"}}>검색</button>
							<FileDownloadComponent
								url={this.getExcelDownloadUrl()}
								obj=""
								val1="none"
							/>
						</div>
					</div>

					<div className="table">
						<table style={{width:"1200px"}}>
							<colgroup>
								<col width="90px" />
								<col width="240px" />
								<col width="180px" />
								<col width="180px" />
								<col width="310px" />
							</colgroup>
							<thead>
								<tr>
									<td>
										<p className="card-text">신청번호</p>
									</td>
									<td>
										<p className="card-text">업체명<br/>(또는 도전자명)</p>
									</td>
									<td>
										<p className="card-text">연락처</p>
									</td>
									<td>
										<p className="card-text">신청일자</p>
									</td>
									<td>
										<p className="card-text">비고</p>
									</td>
								</tr>
							</thead>
							<tbody>
								{this.state.list != null && this.state.list.map(item => (
									<tr key={item.promotion_apply_seq}>
										<td>
											<p className="card-text">{item.promotion_apply_seq}</p>
										</td>
										<td>
											<p className="card-text">{item.company_name}</p>
										</td>
										<td>
											<p className="card-text">{item.phone}</p>
										</td>
										<td>
											<p className="card-text">{item.reg_date_format}</p>
										</td>
										<td>
											<p className="card-text">
												{
													this.state.modRemarkList.indexOf(item.promotion_apply_seq) > -1
													?	<div style={{display:"flex", flexWrap:"nowrap"}}>
															<div style={{width:"100%"}}>
																<textarea
																	id={"remark_" + item.promotion_apply_seq}
																	className="user_remark_text_area"
																	onInput={(e) => this.textAreaAutoResize(e.target)}
																	onChange={(e) => this.onChangeRemarkModText(e, item.promotion_apply_seq)}
																	value={this.state[item.promotion_apply_seq + "_remark"] || ""}
																	style={{width:"100%"}}
																/>
															</div>
															<div className="user_remark_save_btn" style={{flex:"none"}} onClick={() => this.onClickRemarkSaveButton(item.promotion_apply_seq)}>저장</div>
														</div>
													:	<div style={{display:"flex", flexWrap:"nowrap"}}>
															<div style={{width:"100%"}}>
																<textarea
																	id={"remark_" + item.promotion_apply_seq}
																	className="user_remark_text_area"
																	onInput={(e) => this.textAreaAutoResize(e.target)}
																	value={this.state[item.promotion_apply_seq + "_remark"] || ""}
																	readOnly
																	style={{width:"100%"}}
																/>
															</div>
															<div className="user_remark_mod_btn" style={{flex:"none"}} onClick={() => this.onClickRemarkModButton(item.promotion_apply_seq)}>수정</div>
														</div>
												}
											</p>
										</td>
									</tr>
								))}
								{(!this.state.list || this.state.list.length === 0) &&
									<tr>
										<td colSpan="5">
											<p className="card-text">신청 내역이 없습니다.</p>
										</td>
									</tr>
								}
							</tbody>
						</table>
					</div>

					<div className='flexBox' style={{paddingBottom: "50px", fontSize: "18px", maxWidth:"1200px"}}>
						<Pagination
							activePage={this.state.activePage}
							itemsCountPerPage={this.state.rowcnt}
							totalItemsCount={this.state.totalCnt}
							pageRangeDisplayed={5}
							onChange={this.handlePageChange.bind(this)}
						/>
					</div>
				</div>
			</div>
		);
	}
}